import { FeatureFlags, useDevFeature } from '@melio/platform-feature-flags';
import { useConfig } from '@melio/platform-provider';

export const useIsNewDashboardEnabled = () => {
  const config = useConfig();
  const [isNPeOverrideEnabled] = useDevFeature(FeatureFlags.NPEOverride, false);

  return config.settings.newPayExperience.isEnabled || isNPeOverrideEnabled;
};
